<p-dialog id="dialog_createOpportunity" [visible]="showPopup()" (onHide)="closeDialog()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{ '960px': '100vw', '640px': '100vw' }" [style]="{ width: '83vw' }"
  styleClass="no-header-modal" appendToBody="true" aria-label="create-opportunity-dialog" data-testid="create-opportunity-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="frmgroupCreateOpportunity" (ngSubmit)="SaveData()"
      class="m-login-left card border-0 p-sm-0 p-0 start-0 end-0 top-0 bottom-0 scrollable vh-100"
      aria-label="create-opportunity-form" data-testid="create-opportunity-form">
      <div class="xl:flex">
        <!-- Left Side -->
        <div class="xl:w-4 hidden xl:block p-4 hidden surface-0 xl:flex align-items-center justify-content-center">
          <img src="/assets/img/create-opportunity-img2.svg" alt="Image" />
        </div>
        <!-- Left Side -->

        <!-- Right Side -->
        <div class="xl:w-9 border-left-1 border-300">
          <!-- Header -->
          <div class="sticky top-0 left-0 surface-0 z-2 p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
            @if (!_isEditMode) {
              <h2 class="mb-0 text-sm" data-testid="create-opportunity-header">
                {{ 'OPPORTUNITY.CREATE.CREATE-OPPORTUNITY' | translate }}
              </h2>
            }
            @if (_isEditMode) {
              <h2 class="mb-0 text-sm" data-testid="update-opportunity-header">
                {{ 'OPPORTUNITY.CREATE.UPDATE-OPPORTUNITY' | translate }}
              </h2>
            }
            <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="setHidePopup()"
            aria-label="close-opportunity-dialog" data-testid="close-opportunity-dialog"></i>
          </div>

          @if (alreadyOpportunity) {
            <p-message severity="error" icon="fa fa-exclamation-circle" aria-label="opportunity-exists-error" data-testid="opportunity-exists-error">
              {{ 'OPPORTUNITY.CREATE.ALREADY-OPPORTUNITY' | translate }}
            </p-message>
          }

          <!-- Header -->
          <div class="mx-3 my-2 relative z-5">
            @if (showPopup()) {
              <mini-search [readonly]="clientIds && clientIds.length > 0" [id]="clientIds" placeholder="{{'CLIENT_OMNISEARCH.SEARCH_PLACEHOLDER' | translate}}"
                (clients)="setClient($event)" (removedClient)="removedClient()" (createProspect)="createProspect($event)"
                aria-label="client-search-input" data-testid="client-search-input" />
            }
          </div>
          <!-- Header -->

          <!-- Content -->
          <div class="surface-50 text-sm px-3 md:px-4 py-3 border-top-1 border-bottom-1 border-300">
            <div class="grid">
              <div class="col-6 md:col-4">
                <label [for]="'opportunity-stage-dropdown'" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="opportunity-stage-label">
                {{ 'OPPORTUNITY.CREATE.OPPORTUNITY-STAGE' | translate }}</label>
                <p-select [options]="opportunityStageCollection" formControlName="ddlOpportunityStage"
                  optionLabel="name" styleClass="-ml-2 w-full md:w-14rem border-none surface-50"
                  placeholder="{{ 'common.PLACEHOLDER.SELECT' | translate }}"
                  aria-label="opportunity-stage-dropdown" data-testid="opportunity-stage-dropdown">
                  <ng-template pTemplate="selectedItem">
                    @if (SelectedOpportnityStage) {
                      <div data-testid="selected-opportunity-stage">
                        <strong>{{ SelectedOpportnityStage.value.name }}</strong>
                      </div>
                    }
                  </ng-template>
                  <ng-template let-opportunityStageCollection pTemplate="item">
                    <div class="text-sm" [attr.data-testid]="'opportunity-stage-option-' + opportunityStageCollection.id">
                      {{ opportunityStageCollection.name }}
                    </div>
                  </ng-template>
                </p-select>
                @if (
                  SelectedOpportnityStage.touched &&
                  SelectedOpportnityStage.invalid) {
<app-error-msg [errors]="SelectedOpportnityStage.errors" [fieldLabel]="
                    'OPPORTUNITY.CREATE.OPPORTUNITY-STAGE' | translate" data-testid="opportunity-stage-error" />
                }
              </div>
              <div class="col-6 md:col-4">
                <label [for]="'convertibility-dropdown'" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="convertibility-label">
                {{ 'OPPORTUNITY.CREATE.CONVERTIBILITY' | translate }}</label>
                <p-select [options]="convertibility" formControlName="ddlConvertibility" optionLabel="name"
                  styleClass="-ml-2 w-full md:w-14rem border-none surface-50"
                  placeholder="{{ 'common.PLACEHOLDER.SELECT' | translate }}"
                  aria-label="convertibility-dropdown" data-testid="convertibility-dropdown">
                  <ng-template pTemplate="selectedItem">
                    @if (SelectedConvertibility) {
                      <div class="flex align-items-center" data-testid="selected-convertibility">
                        <span class="mr-2"><img width="20" src="{{ SelectedConvertibility.value.icon }}"
                        alt="{{ SelectedConvertibility.value.name }}" /></span>
                        <strong>{{ SelectedConvertibility.value.name }}</strong>
                      </div>
                    }
                  </ng-template>
                  <ng-template let-convertibility pTemplate="item">
                    <div class="flex align-items-center" [attr.data-testid]="'convertibility-option-' + convertibility.id">
                      <span class="mr-2"><img width="20" class="grayscale opacity-50" src="{{ convertibility.icon }}"
                      alt="{{ convertibility.name }}" /></span>
                      <div class="text-sm text-600">
                        {{ convertibility.name }}
                      </div>
                    </div>
                  </ng-template>
                </p-select>
                @if (
                  this.SelectedConvertibility.touched &&
                  this.SelectedConvertibility.invalid) {
                  <app-error-msg [errors]="SelectedConvertibility.errors"
                    [fieldLabel]="'OPPORTUNITY.CREATE.CONVERTIBILITY' | translate" data-testid="convertibility-error" />
                }
              </div>
              <div class="col-12 md:col-4">
                <label [for]="'assigned-to-selector'" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="assigned-to-label">
                {{ 'OPPORTUNITY.CREATE.ASSIGNED-TO' | translate }}</label>
                <staff-selector [formGroup]="frmgroupCreateOpportunity" [controlName]="SelectedAssigned"
                  [id]="_selectedstaff" aria-label="assigned-to-selector" data-testid="assigned-to-selector" />
                @if (
                  this.SelectedAssigned.touched &&
                  this.SelectedAssigned.invalid) {
                  <app-error-msg [errors]="SelectedAssigned.errors" [fieldLabel]="'OPPORTUNITY.CREATE.ASSIGNED-TO' | translate" data-testid="assigned-to-error" />
                }
              </div>
              <!-- <div class="col-6 block md:hidden"></div> -->
              <div class="col-6 md:col-3">
                <label [for]="'opportunity-value-input'" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="opportunity-value-label">
                {{ 'OPPORTUNITY.CREATE.OPPORTUNITY-VALUE' | translate }}</label>
                <p-inputgroup data-testid="opportunity-value-container">
                  <p-inputgroup-addon aria-label="currency-symbol">{{
                    this.country.currency_symbol
                  }}</p-inputgroup-addon>
                  <app-input-number [formGroup]="frmgroupCreateOpportunity" [controlName]="frmgroupCreateOpportunity.get('expectedamount')"
                    [styleClass]="'w-full text-sm'" [conditionToFormat]="true"
                    aria-label="opportunity-value-input" data-testid="opportunity-value-input" />
                </p-inputgroup>
              </div>
              <div class="col-6 md:col-3">
                <label [for]="'closure-date-input'" class="font-medium text-700 text-xs mb-2 white-space-nowrap uppercase" data-testid="closure-date-label">
                {{ 'OPPORTUNITY.CREATE.EXPECTED-CLOUSURE-DATE' | translate }}</label>
                <p-datepicker styleClass="w-full" [showIcon]="true" formControlName="expecteddate" (keyup)="$event.preventDefault()"
                  aria-label="closure-date-input" data-testid="closure-date-input" />
              </div>

              <div class="col-12 md:col-6" style="display:none">
                <label [for]="'referred-by-input'"
                class="font-medium text-700 text-xs mb-2 block white-space-nowrap uppercase">{{'Shared.CREATE-PROSPECT.REFERRED_BY' | translate}}</label>
                <mini-search class="w-full text-sm" [readonly]="false" [showSelected]="true"
                  (clients)="GetClientReferrel($event)" (removedClient)="removeClient($event)" />
              </div>

            </div>
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3 md:mt-0" />
            <label [for]="'service-type-dropdown'" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="service-type-label">
            {{ 'OPPORTUNITY.CREATE.INTERESTED-IN'| translate }}</label>
            <p-multiSelect [options]="serviceTypeCollection" formControlName="serviceType" [defaultLabel]="'OPPORTUNITY.CREATE.SELECT-SERVICE-TYPE' | translate"
              optionLabel="name" display="chip" styleClass="w-full text-sm"
              (onChange)="onChangeServiceTypeCollection($event)" aria-label="service-type-dropdown" data-testid="service-type-dropdown">
              <ng-template let-serviceType pTemplate="item">
                <div [attr.data-testid]="'service-type-option-' + serviceType.id">
                  {{ serviceType.name }}
                </div>
              </ng-template>
            </p-multiSelect>
            @if (this.ServiceType.touched && ServiceType.invalid) {
              <app-error-msg class="mb-3" [errors]="this.ServiceType.errors" [fieldLabel]="'OPPORTUNITY.CREATE.INTERESTED-IN' | translate" data-testid="service-type-error" />
            }
            <label [for]="'opportunity-title-input'" class="font-medium text-700 text-xs mb-2 mt-3 block uppercase" data-testid="title-label">
            {{ 'OPPORTUNITY.CREATE.TITLE' |translate }}</label>
            <input type="text" pInputText class="w-full" placeholder="" formControlName="title"
              aria-label="opportunity-title-input" data-testid="opportunity-title-input" />
              @if (this.SelectedTitle.touched && this.SelectedTitle.invalid) {
                <app-error-msg [errors]="SelectedTitle.errors" [fieldLabel]="'OPPORTUNITY.CREATE.TITLE' | translate" data-testid="title-error" />
              }
            </div>
            <!-- Content -->

            <!-- Content -->
            <div class="surface-50 px-3 md:px-4 py-3 text-sm border-bottom-1 border-300" data-testid="opportunity-comments">
              <textarea pInputTextarea class="w-full text-sm"
                placeholder="{{ 'common.PLACEHOLDER.COMMENTS' | translate }}" formControlName="comments"
              aria-label="opportunity-comments-input" data-testid="opportunity-comments-input"></textarea>
            </div>
            <!-- Content -->

            <!-- Modal Footer -->
            <div class="sticky bottom-0 left-0 surface-0 z-1 px-3 md:px-4 py-3">
              <div class="flex align-items-center justify-content-between">
                <div class="w-6">
                  <p-button label="{{ 'common.PLACEHOLDER.CANCEL' | translate }}" styleClass="p-button-link text-sm"
                  (click)="setHidePopup()" aria-label="cancel-opportunity-button" data-testid="cancel-opportunity-button" />
                </div>
                <div class="w-6 text-right">
                  @if (!_isEditMode) {
                    <button [loading]="isFormSubmitting" pButton pRipple
                      label="{{ 'common.PLACEHOLDER.CREATE' | translate }}" type="submit" class="text-sm"
                    aria-label="create-opportunity-button" data-testid="create-opportunity-button"></button>
                  }
                  @if (_isEditMode) {
                    <button pButton pRipple label="{{ 'common.PLACEHOLDER.UPDATE' | translate }}"
                      [loading]="isFormSubmitting" type="submit" class="text-sm"
                    aria-label="update-opportunity-button" data-testid="update-opportunity-button"></button>
                  }
                </div>
              </div>
            </div>
            <!-- Modal Footer -->
          </div>
          <!-- Right Side -->
        </div>
      </form>
    </ng-template>
  </p-dialog>

  @if (showErrorPopup | async; as show_Popup) {
    <app-errors [visible]="show_Popup" (onHide)="closeDialog()"  [errorData]="errorMessages" [error]="error"
      (hideErrorPopup)="HideErrorPopup($event)" aria-label="opportunity-error-dialog" data-testid="opportunity-error-dialog" />
  }

  <!-- Models Prospect Start -->
  <!-- <create-client-profile-sidebar *ngIf="showCreateProspectPopup$ | async as showPopup" [showProspect]="showPopup"
  (hideProspect)="hideClientPopup($event)" aria-label="create-prospect-dialog" data-testid="create-prospect-dialog">
</create-client-profile-sidebar> -->
<!-- Models Prospect End -->
